import { render, staticRenderFns } from "./uni-transition.vue?vue&type=template&id=83ae9ffa"
import script from "./uni-transition.vue?vue&type=script&lang=js"
export * from "./uni-transition.vue?vue&type=script&lang=js"
import style0 from "./uni-transition.vue?vue&type=style&index=0&id=83ae9ffa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports